import { FC } from 'react';

import type { SamplerCoverageDeptPattern } from '../../../lib/utils/sampler-coverage-svg-patterns';

const PATTERN_TILE_SIZE = 28;

type SamplerCoverageSvgPatternDefsProps = {
  patterns: SamplerCoverageDeptPattern[];
};

export const SamplerCoverageSvgPatternDefs: FC<
  SamplerCoverageSvgPatternDefsProps
> = ({ patterns }) => {
  if (patterns.length === 0) {
    return null;
  }

  return (
    <defs>
      {patterns.map((pattern) => {
        let offset = 0;

        return (
          <pattern
            height={PATTERN_TILE_SIZE}
            id={pattern.id}
            key={pattern.id}
            patternTransform="rotate(45)"
            patternUnits="userSpaceOnUse"
            width={PATTERN_TILE_SIZE}
          >
            {pattern.segments.map((segment, index) => {
              const width = (PATTERN_TILE_SIZE * segment.percent) / 100;
              const rect = (
                <rect
                  fill={segment.color}
                  height={PATTERN_TILE_SIZE}
                  key={`${pattern.id}-${index}`}
                  width={width}
                  x={offset}
                  y={0}
                />
              );
              offset += width;
              return rect;
            })}
          </pattern>
        );
      })}
    </defs>
  );
};
